import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  CompanyDashboardStats,
  MasterAdminDashboardStats,
  OrgDashboardFull,
  OrgDashboardStats,
  OrgStoresSummary,
} from '@/types/dashboard';

export const dashboardApi = {
  masterStats: () =>
    unwrap(api.get<ApiResponse<MasterAdminDashboardStats>>('/v1/dashboard/master')),

  orgStats: (storeId?: number) =>
    unwrap(
      api.get<ApiResponse<OrgDashboardStats>>('/v1/dashboard/org', {
        params: storeId ? { storeId } : undefined,
      }),
    ),

  storesSummary: () =>
    unwrap(api.get<ApiResponse<OrgStoresSummary>>('/v1/dashboard/org/stores-summary')),

  orgFull: (storeId?: number) =>
    unwrap(
      api.get<ApiResponse<OrgDashboardFull>>('/v1/dashboard/org/full', {
        params: storeId ? { storeId } : undefined,
      }),
    ),

  companyStats: () =>
    unwrap(api.get<ApiResponse<CompanyDashboardStats>>('/v1/dashboard/company')),
};
